module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.loading) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$t('static.orders.shippingConfirm.title')) + "\n          "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.orders.shippingConfirm.title')) + "\n        ")]), _vm._v(" "), (_vm.displayError) ? _c('el-alert', {
    attrs: {
      "show-icon": "",
      "title": _vm.$t('static.orders.shippingConfirm.shippingProviderRequired'),
      "type": "error",
      "center": "",
      "closable": false
    }
  }, [(_vm.displayError) ? _c('div', {
    staticStyle: {
      "padding": "5px 0",
      "text-decoration": "underline"
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/inventory/warehouse/" + _vm.warehouseId + "/edit#basics"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.orders.shippingConfirm.addShippingProviderBtn')))])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.shippingConfirm",
      "hasLabel": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showReminder && _vm.currentOrder.orderType != 'EDI') ? _c('div', [(_vm.currentOrder.internalNote !== '') ? _c('div', [_c('span', {
    staticClass: "label-content label-content--small",
    staticStyle: {
      "font-weight": "900",
      "margin-bottom": "10px",
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.collicareConfirmedShippingReminder')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #f8e4c5",
      "padding": "6px 18px",
      "margin-bottom": "20px",
      "background": "#fff1dc"
    }
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.currentOrder.internalNote.replace(/\r\n/g, '<br>'))
    }
  })])]) : _c('div', [_c('span', {
    staticClass: "label-content label-content--small",
    staticStyle: {
      "font-weight": "900",
      "margin-bottom": "10px",
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.collicareConfirmedShippingReminderEmpty')))])])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.closeModal(_vm.dashboard)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "disabled": _vm.displayError || (_vm.currentOrder.internalNote === '' && _vm.showReminder && _vm.currentOrder.orderType != 'EDI'),
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.store
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1047e68b","hasScoped":false}!./src/app/components/orderConfirmShipping/orderConfirmShipping.html
// module id = 2914
// module chunks = 1